<template>
  <div class="mention-dropdown">
    <template v-if="items.length">
      <button
        v-for="(item, index) in items"
        :key="item.id || index"
        :ref="index === selectedIndex ? 'selectedItem' : undefined"
        :class="['mention-item', { 'is-selected': index === selectedIndex }]"
        @click="selectItem(index)"
      >
        <span :class="['editor-variable-chip', item.colorClass]">
          {{ item.label || item.id }}
        </span>
      </button>
    </template>
    <div v-else class="mention-empty">
      Nenhuma variável encontrada
    </div>
  </div>
</template>

<script>
export default {
  name: 'MentionList',

  props: {
    items: {
      type: Array,
      required: true
    },
    command: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      selectedIndex: 0
    }
  },

  watch: {
    items () {
      this.selectedIndex = 0
    },
    selectedIndex () {
      this.scrollToSelected()
    }
  },

  methods: {
    onKeyDown ({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        this.downHandler()
        return true
      }

      if (event.key === 'Enter' || event.key === 'Tab') {
        this.enterHandler()
        return true
      }

      return false
    },

    upHandler () {
      this.selectedIndex = (this.selectedIndex + this.items.length - 1) % this.items.length
    },

    downHandler () {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length
    },

    enterHandler () {
      this.selectItem(this.selectedIndex)
    },

    selectItem (index) {
      const item = this.items[index]
      if (item) {
        this.command(item)
      }
    },

    scrollToSelected () {
      this.$nextTick(() => {
        const selectedElement = this.$refs.selectedItem
        if (selectedElement && selectedElement[0]) {
          selectedElement[0].scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.mention-dropdown {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 280px;
  overflow: auto;
  padding: 8px;
  min-width: 220px;
  z-index: 9999;
}

.mention-item {
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  padding: 4px 8px;
  text-align: left;
  transition: background-color 0.15s ease;
  width: 100%;
}

.mention-item:hover {
  background-color: #f5f5f5;
}

.mention-item.is-selected {
  background-color: #1976d2;
}

.mention-empty {
  color: #9e9e9e;
  font-size: 12px;
  padding: 8px;
  text-align: center;
}

</style>
